import { ChatMessageControllerApi } from "../../../../../services";
import { getConfigObject, getXtenantId, useMutationWithLoading } from "../../../../../utils/utils";


/**
 * @author [Rajkumar Rathod]
 */
export const useChatAttachmentUpload = () =>
    useMutationWithLoading(async (file: File) =>
        new ChatMessageControllerApi(getConfigObject()).uploadChatAttachment(
            file,
            getXtenantId()
        )
    );
